import { WrapperRelative as WrapperRelativeDefault } from '~components'
import styled from 'styled-components'

export const WrapperRelative = styled(WrapperRelativeDefault)`
  margin-bottom: ${({ theme }) => theme.spacing.km4};

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    margin-bottom: ${({ theme }) => theme.spacing.km3};
  }

  input:not(:last-child) {
    padding: ${({ theme }) => theme.spacing.km0} ${({ theme }) => theme.spacing.km10}
      ${({ theme }) => theme.spacing.km0} ${({ theme }) => theme.spacing.km3};
  }

  &
    > input:not(:focus)
    + svg:is([aria-label='show-password'], [aria-label='hide-password']) {
    & > path {
      stroke: #7b829d;
    }
  }

  &
    > input:not(:placeholder-shown)
    + svg:is([aria-label='show-password'], [aria-label='hide-password']) {
    & > path {
      stroke: #232b43;
    }
  }
`
